var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_c('a-modal',_vm._g(_vm._b({attrs:{"centered":true,"title":_vm.title,"width":"50%"}},'a-modal',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.data),function(item,index){return _c('p',{key:index,staticClass:"home_dialog_text"},[_vm._v(_vm._s(item))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }